import { onMounted, onUnmounted } from 'vue';

export function useViewportHeight() {
  const updateVisualHeight = () => {
    const visualHeight = window.visualViewport
      ? window.visualViewport.height
      : window.innerHeight;
    document.documentElement.style.setProperty('--vh', `${visualHeight}px`);
  };

  onMounted(() => {
    window.addEventListener('resize', updateVisualHeight);
    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', updateVisualHeight);
      window.visualViewport.addEventListener('scroll', updateVisualHeight);
    }
    updateVisualHeight();
  });

  onUnmounted(() => {
    window.removeEventListener('resize', updateVisualHeight);
    if (window.visualViewport) {
      window.visualViewport.removeEventListener('resize', updateVisualHeight);
      window.visualViewport.removeEventListener('scroll', updateVisualHeight);
    }
  });
}
